module.exports = __webpack_public_path__ + "media/images/logo-320-8824996c9b74f3276642cfd8b0353ade.jpg";